import { IDialogAction } from './IDialogAction';
import { DialogState } from '../../dialog-feed/models/DialogState';

export const LIKE_ADDED = 'LIKE_ADDED';

export class LikeAddedAction implements IDialogAction {
    public readonly type = LIKE_ADDED;
    public constructor(public payload: any) {}
    public reducer(state: DialogState): DialogState {
        if(this.payload.ids.length > 2) {
            state.feed.messages.forEach(m => {
                m.comments.forEach(c => {
                    c.comments.forEach(ic => {
                        if(+ic.id !== this.payload.ids[2]) {
                            return;
                        }
                        if(ic.likes.filter(l => l.externalId === this.payload.user.x).length) {
                            return;
                        }
                        if(state.feed.currentUser.externalId === this.payload.user.x) {
                            ic.liked = true;
                        }
                        ic.likes.push({
                            id: '',
                            externalId: this.payload.user.x,
                            name: this.payload.user.u,
                            profileUrl: `/_layouts/15/me.aspx?p=${this.payload.user.x}`,
                            profilePhotoUrl: `/_layouts/15/userphoto.aspx?size=M&accountname=i%3A0%23.f%7Cmembership%7C${encodeURIComponent(this.payload.user.x)}`
                        });
                    });
                });
            });
        }
        else if(this.payload.ids.length > 1) {
            state.feed.messages.forEach(m => {
                m.comments.forEach(c => {
                    if(+c.id !== this.payload.ids[1]) {
                        return;
                    }
                    if(c.likes.filter(l => l.externalId === this.payload.user.x).length) {
                        return;
                    }
                    if(state.feed.currentUser.externalId === this.payload.user.x) {
                        c.liked = true;
                    }
                    c.likes.push({
                        id: '',
                        externalId: this.payload.user.x,
                        name: this.payload.user.u,
                        profileUrl: `/_layouts/15/me.aspx?p=${this.payload.user.x}`,
                        profilePhotoUrl: `/_layouts/15/userphoto.aspx?size=M&accountname=i%3A0%23.f%7Cmembership%7C${encodeURIComponent(this.payload.user.x)}`
                    });
                });
            });
        }
        else if(this.payload.ids.length > 0) {
            state.feed.messages.forEach(m => {
                if(+m.id !== this.payload.ids[0]) {
                    return;
                }
                if(m.likes.filter(l => l.externalId === this.payload.user.x).length) {
                    return;
                }
                if(state.feed.currentUser.externalId === this.payload.user.x) {
                    m.liked = true;
                }
                m.likes.push({
                    id: '',
                    externalId: this.payload.user.x,
                    name: this.payload.user.u,
                    profileUrl: `/_layouts/15/me.aspx?p=${this.payload.user.x}`,
                    profilePhotoUrl: `/_layouts/15/userphoto.aspx?size=M&accountname=i%3A0%23.f%7Cmembership%7C${encodeURIComponent(this.payload.user.x)}`
                });
            });
        }
        return state;
    }
}

export const LikeAddedActionTypeMapping = {
    [LIKE_ADDED]: LikeAddedAction
};